import React from "react";
import { Button, Typography, Box } from "@mui/joy";
import { Lock, ShieldCheck } from "lucide-react";

export default function Hero({ dark }: { dark: boolean }) {
  return (
    <Box
      sx={[
        (theme) => ({
          py: 25,
          px: {
            xs: 0,
            md: 15,
            lg: 25
          },
          background: dark
            ? `linear-gradient(to right, #4c1d95, #1e3a8a)`
            : `linear-gradient(to right, #8b5cf6, #38BDF8)`,
        }),
      ]}
    >
      <div className="container px-4 md:px-6 relative z-10 mx-auto">
        <div
          className={`flex flex-col items-center space-y-4 text-center ${
            dark ? "text-gray-300" : "text-white"
          }`}
        >
          <div className="space-y-6">
            <h1 className="text-5xl font-bold tracking-normal sm:text-4xl md:text-5xl lg:text-6xl/none">
              Master the Art of Cybersecurity with HackTheWay
            </h1>
            <p
              className={`mx-auto max-w-[700px] ${
                dark ? "text-gray-300" : "text-gray-200"
              } md:text-xl`}
            >
              Join the ultimate platform for CTF challenges, bug bounties, and
              comprehensive security learning across IT, IoT, and OT domains.
              Hack, learn, and secure the future!
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              size="lg"
              className={`${
                dark ? "bg-gray-800 text-[#7B3FE4]" : "bg-white text-[#7B3FE4]"
              } hover:bg-gray-100`}
              sx={{ width: "15rem" }}
              onClick={() => {
                window.open("/signup", "_blank");
              }}
            >
              <Lock className="mr-2 h-4 w-4" />
              Start Hacking
            </Button>
            <Button
              variant="outlined"
              size="lg"
              sx={{ width: "15rem" }}
              className={`${
                dark
                  ? "text-gray-300 border-gray-300 hover:bg-gray-800"
                  : "text-white border-white hover:bg-white/20"
              }`}
              onClick={() => {
                window.open("/challenges", "_blank");
              }}
            >
              <ShieldCheck className="mr-2 h-4 w-4" />
              Explore Challenges
            </Button>
          </div>
        </div>
      </div>
    </Box>
  );
}
